export class Configuration {

  // ---------------------------------------------------------------------------------------
  // URLS FOR STAGE SERVER / STAGE END POINTS
  // ---------------------------------------------------------------------------------------
  public static portalUrl:string = "https://staging.protoexpress.com/";
  public static oneFlowUrl:string = "https://oneflowbackendqa.app.protoexpress.com/api";
  public static scaBomUrl:string = "https://scastaging.app.protoexpress.com";
  // private REST_API_SERVER = "https://stagingkicad6.app.protoexpress.com/";
  // private REST_API_SERVER = "https://stagingkicad.app.protoexpress.com/";
  public static REST_API_SERVER:string =  "https://qakicad.app.protoexpress.com/";
  //private FEMS_STG_URL = "https://staging.protoexpress.com/sierra-app/";
  // private Kicad_Dev_Url : string = "https://api.protoexpress-api.net/kidev";
  public static Guest_Email_Url:string = this.oneFlowUrl + "/oneflow/guestEmailInfo";
  public static Pcb_Quote_Url:string = this.oneFlowUrl + "/oneflow/";
  public static MAIN_URL:string = "https://customerstagingbackend.app.protoexpress.com";
  public static backendStagingServer:string = this.oneFlowUrl + "/oneflow";
  public static sierraStandardProductLink:string = "https://www.protoexpress.com/products/sierra-standard-product/";
  // private AppLocationBaseURL : string = "https://api.protoexpress-api.net/dev";
  public static AppLocationBaseURL : string = this.scaBomUrl + "/bom";
  public static ADDRESS_REQUEST_URL : string = this.oneFlowUrl + "/oneflow";
  public static Order_Url : string = this.oneFlowUrl + "/oneflow";
  public static autoBOMFileDownloadUrl: string = "https://qakicad.app.protoexpress.com/superAPI?service=getFile&fileName=";
  // autoBOMFileDownloadUrl = "https://stagingkicad.app.protoexpress.com/superAPI?service=getFile&fileName=";
  // scaBOMFileDownloadUrl = this.scaBomUrl + "/bom/download/";
  public static scaBOMFileDownloadUrl:string = this.oneFlowUrl + "/oneflow/download-bom?bomId=";
  public static Pcb_Specification_URL:string = this.portalUrl + "products/online-pcb-manufacturing/";
  public static Via_In_Pad_URL:string = this.portalUrl + "customer-portal/via-in-pad-features.jsp";
  public static Terms_And_Conditions_URL:string = this.portalUrl + "terms-and-conditions/";
  public static Customer_Care_URL:string = this.portalUrl + "customer-portal/customer-services/";
  public static FAQ_URL:string = this.portalUrl + "faq/web-order-pcbs/"
  public static QA_ORDER_URL:string = this.oneFlowUrl + "/oneflow/";
  public static stagOneflowUrl:string = 'https://oneflowstaging.app.protoexpress.com';
  public static resaleCertiUrl:string = 'https://staging.protoexpress.com/fabuser/BlankResaleCertificate.pdf';
  public static stagingPortalUrl :string = 'https://staging.protoexpress.com';
  public static customerPortalUrl:string = 'https://staging.protoexpress.com/customer-portal/chkAuth/session-status-fems.jsp';
//  public static customQuoteUrl:string = 'https://stagingcustomquote.app.protoexpress.com/custom-quote/upload-file';
  public static customQuoteUrl:string = 'https://staging.protoexpress.com/customer-portal/custom-quote';
  public static fpHpcBaseUrl:string = 'https://hpc.uat.freedompay.com';
}
